module.exports = __webpack_public_path__ + "static/media/card-error-icon.b24b377a.png";